const getJwt = () => localStorage.getItem("jwt");

const setJwt = (token: string) => localStorage.setItem("jwt", token);

const removeJwt = () => localStorage.removeItem("jwt");

export { getJwt, setJwt, removeJwt };
